import * as React from "react";

interface SVGRProps {
	title?: string;
	titleId?: string;
}

function SvgLargeDropdownclosed({
	title,
	titleId,
	...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
	return (
		<svg
			width={24}
			height={24}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			aria-labelledby={titleId}
			{...props}
		>
			{title ? <title id={titleId}>{title}</title> : null}
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.613 11.21l.094.083L12 18.585l7.293-7.292a1 1 0 011.32-.083l.094.083a1 1 0 01.083 1.32l-.083.094-8 8a1 1 0 01-1.32.083l-.094-.083-8-8a1 1 0 011.32-1.497zm0-8l.094.083L12 10.585l7.293-7.292a1 1 0 011.32-.083l.094.083a1 1 0 01.083 1.32l-.083.094-8 8a1 1 0 01-1.32.083l-.094-.083-8-8a1 1 0 011.32-1.497z"
			/>
		</svg>
	);
}

const MemoSvgLargeDropdownclosed = React.memo(SvgLargeDropdownclosed);
export default MemoSvgLargeDropdownclosed;
